import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BtnLanguageComponent } from '@b2b/features/misc/language-selector/btn-language/btn-language.component';

@NgModule({
  imports: [CommonModule, TranslateModule, BtnLanguageComponent],
  exports: [BtnLanguageComponent],
})
export class LanguageSelectorModule {}
